@if (flag(); as f) {
  <div
    class="recovery-flag"
    [class.recovery-flag--serious]="f.severity === 'SERIOUS'"
    role="alert"
  >
    <app-icon name="alert-triangle" [size]="16" aria-hidden="true" />
    <!-- DOC-52 §2 requires the banner to state the value *and* the severity.
         The severity rides as text, not colour alone — amber-vs-red is
         invisible to a colour-blind reviewer and to a screen reader. -->
    <span class="recovery-flag__severity">{{ severityLabel() }}</span>
    <span>{{ f.label }}</span>
  </div>
}
